import Axios from "axios";
import {
  SET_PRODUCTION_FINISHING_LIST,
  UNSET_PRODUCTION_FINISHING_LIST,
  SET_PRODUCTION_FINISHING_INPUT_LIST,
  UNSET_PRODUCTION_FINISHING_INPUT_LIST,
  SET_PRODUCTION_FINISHING_OUTPUT_LIST,
  UNSET_PRODUCTION_FINISHING_OUTPUT_LIST,
} from "@/store/mutation-types";
import { 
  finishingResource,
  finishingInputResource, 
  finishingOutputResource 
} from "@/store/api";

// Initial State
const state = {
  getProductionFinishingList: [],
  getProductionFinishingInputList: [],
  getProductionFinishingOutputList: [],
};

// Getters
const getters = {
  getProductionFinishingList(state) {
    return state.getProductionFinishingList;
  },
  getProductionFinishingInputList(state) {
    return state.getProductionFinishingInputList;
  },
  getProductionFinishingOutputList(state) {
    return state.getProductionFinishingOutputList;
  },
};

// Mutations
const mutations = {
  [SET_PRODUCTION_FINISHING_LIST](state, data) {
    state.getProductionFinishingList = data;
  },
  [UNSET_PRODUCTION_FINISHING_LIST](state) {
    state.getProductionFinishingList = [];
  },
  [SET_PRODUCTION_FINISHING_INPUT_LIST](state, data) {
    state.getProductionFinishingInputList = data;
  },
  [UNSET_PRODUCTION_FINISHING_INPUT_LIST](state) {
    state.getProductionFinishingInputList = [];
  },
  [SET_PRODUCTION_FINISHING_OUTPUT_LIST](state, data) {
    state.getProductionFinishingOutputList = data;
  },
  [UNSET_PRODUCTION_FINISHING_OUTPUT_LIST](state) {
    state.getProductionFinishingOutputList = [];
  },
};

// Actions
const actions = {


  saveProductionFinishing({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(finishingResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  updateProductionFinishing({ commit }, { id, data }) {
      commit("SET_LOADING", { color: "primary" });

      const url = `${finishingResource}/${id}`;

      return new Promise((resolve, reject) => {
      Axios.put(url, data)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },

  getProductionFinishingList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(finishingResource)
        .then((response) => {
          commit(SET_PRODUCTION_FINISHING_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_FINISHING_LIST);
          reject(error);
        });
    });
  },

  getProductionFinishingById({ commit }, { id }) {
      commit("SET_LOADING", { color: "primary" });
      const url = `${finishingResource}/${id}`;
      return new Promise((resolve, reject) => {
      Axios.get(url)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },

  saveProductionFinishingInput({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(finishingInputResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // FINISHING OUTPUT
  saveProductionFinishingOutput({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(finishingOutputResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};


